import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Zoom from '@mui/material/Zoom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

import AuthLayout from './AuthLayout';

interface RequestSentScreenProps {
    clubName: string;
    ctaLabel: string;
    ctaHref: string;
}

// A full-screen animated confirmation, shared by every "your request to
// join a club was transmitted" moment: manual signup, social signup, and
// an already-logged-in user joining an additional club from the directory.
export default function RequestSentScreen({ clubName, ctaLabel, ctaHref }: RequestSentScreenProps) {
    const { t } = useTranslation();

    return (
        <AuthLayout maxWidth="xs">
            <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" gap={2}>
                <Zoom in timeout={500}>
                    <CheckCircleOutlineIcon color="success" sx={{ fontSize: 88 }} />
                </Zoom>
                <Typography variant="h5" fontWeight={700}>
                    {t('signup.requestSentTitle')}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    {t('signup.requestSentBody', { clubName: clubName || t('signup.thisClub') })}
                </Typography>
                <Button href={ctaHref} variant="contained" color="primary" sx={{ mt: 1 }}>
                    {ctaLabel}
                </Button>
            </Box>
        </AuthLayout>
    );
}
